<app-nav></app-nav>
<section class="personalAccident-quote-details" *ngIf="quotesDetailsTable && !proposalFormDPI">
  <div class="breadcrumbs text-center">
    <span routerLink="/home">Home</span>
    <span routerLink="/doctor-professional-indemnity">Doctors Professional Indemnity</span>
    <span>Quote</span>
  </div>
  <div class="proposed-limit-section">
    <p class="heading mb-2">Proposed Quote</p>
    <p class="sub-heading">Limit of Indemnity (LOI)</p>
    <select class="form-control" class="form-control" [(ngModel)]="selectedLOI" (change)="changeLOI()">
      <option value="30 Lacs" selected="">30 Lacs</option>
      <option value="50 Lacs">50 Lacs</option>
      <option value="70 Lacs">70 Lacs</option>
      <option value="1 Crore">1 Crore</option>
      <option value="2 Crore">2 Crore</option>
      <option value="3 Crore">3 Crore</option>
      <option value="4 Crore">4 Crore</option>
      <option value="5 Crore">5 Crore</option>
      <option value="10 Crore">10 Crore</option>
      <option value="25 Crore">25 Crore</option>
      <option value="50 Crore">50 Crore</option>
    </select>
  </div>
  <div class="proposed-limit-section">
    <p class="sub-heading">Territory & Jurisdiction</p>
    <select class="form-control" class="form-control" [(ngModel)]="selectedTerritory" (change)="changeTerritory()">
      <option value="India" selected="">India</option>
      <option value="Worldwide excluding US/Canada">Worldwide excluding US/Canada</option>
      <option value="Worldwide">Worldwide</option>
    </select>
  </div>

  <div class="quote-summary" *ngIf="SectionFutureGenerali">
    <div class="insurer-logo" *ngIf="insurerLogo">
      <div class="logo-links">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/future-generali-logo-new.jpg"
          width="30%">
      </div>
    </div>
    <div class="premium-details">
      <div class="noInsurerLogo">
        <div class="premium-amount d-flex">
          <div class="p-2 mr-auto mt-3">
            <p class="title">Total Premium</p>
            <p class="sub-title">(INR,Excluding Taxes)</p>
          </div>
          <div class="p-2">
            <span class="rupees-symbol">&#8377;</span><span
              class="amount">{{quoteDataGenerali.XLEW_5_6_4 | number}}</span>
          </div>
        </div>
        <div class="d-flex premium-summary">
          <div class="p-2 mr-auto left-box">
            <span>Territory & Jurisdiction</span>
          </div>
          <div class="p-2">
            <span>{{quoteDataGenerali.XLEW_5_11_4}}</span>
          </div>
        </div>
        <div class="d-flex premium-summary">
          <div class="pl-2 mr-auto left-box">
            <span>Excess: India</span>
          </div>
          <div class="pr-2 right-box">
            <span>{{quoteDataGenerali.XLEW_5_9_4}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="col p-2 d-flex">
              <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse"
                data-target="#detailed-section-generali">
                <span class="if-collapsed"></span>
              </button>
              <span><a href="javascript:void(0)" class="downloadPDF" (click)="downloadPDF('futureGenerali')"></a></span>
              <span><button type="button" class="btn btn-bordered-blue btn-buy sendPdf"
                  (click)="openModal(templateThankYou);sendPDF('futureGenerali')">Email</button></span>
              <button class="btn-filled-orange pull-right"
                (click)="openModal(calculationTemplateGenerali);calculatePremium(quoteDataGenerali.XLEW_5_6_4, 'futureGenerali')">Buy
              </button>
            </div>
          </div>
        </div>
        <div id="detailed-section-generali" class="collapse">
          <div class="quote-section">
            <div class="premium-summary p-2">
              <p class="title">
                Coves Opted for
              </p>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Limit of Indemnity</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataGenerali.XLEW_5_8_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Any One Accident : Any One Year (AOY:AOY)</span>
              </div>
              <div class="right-box">
                <span>1:1</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Defence Cost</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataGenerali.XLEW_5_17_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Loss of Documents</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataGenerali.XLEW_5_13_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Libel & Slander</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataGenerali.XLEW_5_14_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Defamation</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataGenerali.XLEW_5_15_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Breach of Confidential Information</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataGenerali.XLEW_5_16_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Pre-litigation cost</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataGenerali.XLEW_5_17_4}}</span>
              </div>
            </div>
          </div>
          <div class="quote-section">
            <div class="premium-summary p-2">
              <p class="title">
                Conditions
              </p>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Basis of Coverage</span>
              </div>
              <div class="right-box">
                <span>Claims made policy</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Filled-Up Proposal Form</span>
              </div>
              <div class="right-box">
                <icon class="right"></icon>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Retroactive Date for Renewal Cases</span>
              </div>
              <div class="right-box">
                <span>Covered</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>No known or reported losses in last 5 years</span>
              </div>
              <div class="right-box">
                <icon class="right"></icon>
              </div>
            </div>
          </div>
          <div class="note">
            <p>NOTE : THESE ARE INDICATIVE PRICES. INSURANCE IS THE SUBJECT
              MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <span id="snackbar"></span>
  <div class="quote-summary" *ngIf="sectionUnitedIndia">
    <div class="insurer-logo" *ngIf="insurerLogo">
      <div class="logo-links">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/insurers/united-india.png">
      </div>
    </div>
    <div class="premium-details">
      <div class="noInsurerLogo">
        <div class="premium-amount d-flex">
          <div class="p-2 mr-auto">
            <p class="title">Total Premium</p>
            <p class="sub-title">(INR,Excluding Taxes)</p>
          </div>
          <div class="p-2">
            <span class="rupees-symbol">&#8377;</span><span
              class="amount">{{quoteDataUnitedIndia.XLEW_5_6_4 | number}}</span>
          </div>
        </div>
        <div class="d-flex premium-summary">
          <div class="p-2 mr-auto left-box">
            <span>Territory & Jurisdiction</span>
          </div>
          <div class="p-2">
            <span>{{quoteDataUnitedIndia.XLEW_5_3_4}}</span>
          </div>
        </div>
        <div class="d-flex premium-summary">
          <div class="pl-2 mr-auto left-box">
            <span>Excess: India</span>
          </div>
          <div class="pr-2 right-box">
            <span>{{quoteDataUnitedIndia.XLEW_5_9_4}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="col p-2 d-flex">
              <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse"
                data-target="#detailed-section-united">
                <span class="if-collapsed"></span>
              </button>
              <span><a href="javascript:void(0)" class="downloadPDF" (click)="downloadPDF('unitedIndia')"></a></span>
              <span><button type="button" class="btn btn-bordered-blue btn-buy sendPdf"
                  (click)="openModal(templateThankYou);sendPDF('unitedIndia')">Email</button></span>
              <button class="btn-filled-orange pull-right"
                (click)="openModal(calculationTemplateGenerali);calculatePremium(quoteDataUnitedIndia.XLEW_5_6_4, 'unitedIndia');">Buy
              </button>
            </div>
          </div>
        </div>
        <div id="detailed-section-united" class="collapse">
          <div class="quote-section">
            <div class="premium-summary p-2">
              <p class="title">
                Coves Opted for
              </p>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Limit of Indemnity</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataUnitedIndia.XLEW_5_8_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Any One Accident : Any One Year (AOY:AOY)</span>
              </div>
              <div class="right-box">
                <span>1:1</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Defence Cost</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataUnitedIndia.XLEW_5_17_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Loss of Documents</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataUnitedIndia.XLEW_5_13_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Libel & Slander</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataUnitedIndia.XLEW_5_14_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Defamation</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataUnitedIndia.XLEW_5_15_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Breach of Confidential Information</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataUnitedIndia.XLEW_5_16_4}}</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Out of court settlement</span>
              </div>
              <div class="right-box">
                <span>{{quoteDataUnitedIndia.XLEW_5_18_4}}</span>
              </div>
            </div>
          </div>
          <div class="quote-section">
            <div class="premium-summary p-2">
              <p class="title">
                Conditions
              </p>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Basis of Coverage</span>
              </div>
              <div class="right-box">
                <span>Claims made policy</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Filled-Up Proposal Form</span>
              </div>
              <div class="right-box">
                <icon class="right"></icon>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>Retroactive Date for Renewal Cases</span>
              </div>
              <div class="right-box">
                <span>Covered</span>
              </div>
            </div>
            <div class="d-flex premium-detailed-summary">
              <div class="left-box">
                <span>No known or reported losses in last 5 years</span>
              </div>
              <div class="right-box">
                <icon class="right"></icon>
              </div>
            </div>
          </div>
          <div class="note">
            <p>NOTE : THESE ARE INDICATIVE PRICES. INSURANCE IS THE SUBJECT
              MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<!-- <section class="intimate-successfull" *ngIf="thankYou">
  <div class="container">
    <div class="col-12 thankYouContainer">
      <h4 class="thankyou-heading">Thank You</h4>
      <hr>
      <p>We will call you back soon within 24 hours.</p>
    </div>
  </div>
</section> -->
<ng-template #calculationTemplateGenerali>
  <!-- <form name="form" (ngSubmit)="payment.form.valid" #payment="ngForm"> -->
  <div class="modal-body">
    <div class="col">
      <h4 *ngIf="!thankYou" class="modal-title">Summary Details</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="col text-center mt-4" *ngIf=!thankYou>
      <p class="title">Premium (Including taxes)</p>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <p>Base Premium</p>
              <p>Service Tax</p>
            </div>
            <div class="col-6">
              <p><span class="rupees-symbol">&#8377;</span> {{totalPremium | number}}</p>
              <p><span class="rupees-symbol">&#8377;</span> {{serviceTax | number}}</p>
            </div>
          </div>
        </div>
        <hr>
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <p>Total Premium</p>
            </div>
            <div class="col-6">
              <p><span class="rupees-symbol">&#8377;</span> {{totalPremiumIncludedTax | number}}</p>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="col text-center mt-4" *ngIf="!thankYou">
      <button *ngIf="totalPremiumForFutureGenerali" class="btn btn-bordered-blue" aria-label="Close"
        (click)="modalRef.hide();initiatePaymentForGenerali(quoteDataGenerali.XLEW_5_6_4);">CONFIRM AND PROCEED</button>
      <button *ngIf="totalPremiumForUnitedIndia" class="btn btn-bordered-blue" aria-label="Close"
        (click)="modalRef.hide();initiatePaymentForUnitedIndia(quoteDataUnitedIndia.XLEW_5_6_4);">CONFIRM AND
        PROCEED</button>
    </div>
    <div class="col text-center mt-4">
      <div class="container" *ngIf="thankYou">
        <div class="col-12 thankYouContainer">
          <h4 class="thankyou-heading">Thank You</h4>
          <hr>
          <p>We will call you back soon within 24 hours.</p>
        </div>
      </div>
    </div>
  </div>
  <!-- </form> -->
</ng-template>
<ng-template #templateThankYou>
  <!-- <div class="modal-header">
      
    </div> -->
  <form name="form" (ngSubmit)="f.form.valid" #f="ngForm">
    <div class="modal-body" id="contactInfoModal">
      <div class="col">
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col text-center mt-4">
        <h4 class="modal-title">Thank You</h4>
        <p>We will call you back within 24 hours.</p>
        <p>A detailed quote has been emailed to you.</p>
      </div>
    </div>
  </form>

</ng-template>